import React from 'react';
import { WarehouseCard } from './WarehouseCard';
export function WarehouseGrid({
  onViewDetails
}) {
  const warehouses = [{
    id: 'IR1',
    name: 'Alkhorayef Manufacture - Riyadh',
    location: 'Saudi Arabia',
    flag: '🇸🇦',
    stock: '0%',
    machines: '0'
  }, {
    id: 'IU1',
    name: 'Pierce - San Antonio',
    location: '6203 Woodlake Center TEXAS San Antonio United States',
    flag: '🇺🇸',
    stock: '2%',
    machines: '7'
  }, {
    id: 'IS2',
    name: 'AISco - Albacete',
    location: 'Avenida Sexta nº 5 Poligono Industrial Campo LLano Albacete Spain',
    flag: '🇪🇸',
    stock: '-100%',
    machines: '-1'
  }, {
    id: 'IR5',
    name: 'Oracle Master',
    location: 'Saudi Arabia',
    flag: '🇸🇦',
    stock: '0%',
    machines: '0'
  }, {
    id: 'IE5',
    name: 'AIC TOM Egypt - Pivots',
    location: 'Egypt',
    flag: '🇪🇬',
    stock: '0%',
    machines: '0'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-6982">
      {warehouses.map(warehouse => <WarehouseCard key={warehouse.id} id={warehouse.id} name={warehouse.name} location={warehouse.location} country={warehouse.location.split(' ').pop()} flag={warehouse.flag} stock={warehouse.stock} machines={warehouse.machines} onViewDetails={() => onViewDetails(warehouse)} data-id="element-6983" />)}
    </div>;
}